import type { Artist } from './artist-types';
import type { TypesenseCarouselTile } from './carousel-documents';

export const CONTRIBUTOR_ASSET_TYPES = [
  'music',
  'sfx',
  'stock-video',
  'motion-graphics',
  'luts',
] as const;

export type ContributorAssetType = (typeof CONTRIBUTOR_ASSET_TYPES)[number];

export const isContributorAssetType = (
  value: unknown
): value is ContributorAssetType =>
  typeof value === 'string' &&
  (CONTRIBUTOR_ASSET_TYPES as readonly string[]).includes(value);

export interface ContributorProfile extends Artist {
  assetTypes: ContributorAssetType[];
  featuredTiles?: Partial<
    Record<ContributorAssetType, TypesenseCarouselTile[]>
  >;
}
